import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RoutingService } from 'src/app/core/services/routing.service';
import { MatDialog } from '@angular/material/dialog';
import { InviteDialogComponent } from '../../html-css/invite-dialog/invite-dialog.component';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-organization-profile',
  styleUrls: ['./organization-profile.component.scss'],
  templateUrl: './organization-profile.component.html'
})
export class OrganizationProfileComponent {
  @Input() isAuthView: boolean;
  @Input() isMy: boolean;
  @Input() organization: any;

  @Output() subscribe = new EventEmitter<string>();
  @Output() unsubscribe = new EventEmitter<string>();
  @Output() message = new EventEmitter<void>();
  @Output() openAbout = new EventEmitter<void>();
  @Output() inviteEmail = new EventEmitter<{ email: string; orgId: string }>();

  get isDefaultBg() {
    return this.organization.icon_bg === '/img/default/icon/org.jpg';
  }

  constructor(
    private routingService: RoutingService,
    private dialog: MatDialog
  ) {}

  get settings() {
    return this.routingService.orgSettings().toString();
  }

  onSubscribe() {
    this.subscribe.emit(this.organization.id);
  }

  onUnsubscribe() {
    this.unsubscribe.emit(this.organization.id);
  }

  onMessage() {
    this.message.emit();
  }

  onAbout() {
    this.openAbout.emit();
  }

  openInviteDialog() {
    const dialogRef = this.dialog
      .open(InviteDialogComponent)
      .afterClosed()
      .pipe(
        filter((val) => val.email),
        take(1)
      )
      .subscribe((res) => {
        this.inviteEmail.emit({
          email: res.email,
          orgId: this.organization.id
        });
      });
  }
}
